import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaSplitterTriggerDefaultVariants = {}
const aromaSplitterTriggerCompoundVariants = []

const aromaSplitterTriggerSlotNames = [
  [
    "trigger",
    "aroma-splitter-trigger__trigger"
  ],
  [
    "button",
    "aroma-splitter-trigger__button"
  ]
]
const aromaSplitterTriggerSlotFns = /* @__PURE__ */ aromaSplitterTriggerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaSplitterTriggerDefaultVariants, getSlotCompoundVariant(aromaSplitterTriggerCompoundVariants, slotName))])

const aromaSplitterTriggerFn = memo((props = {}) => {
  return Object.fromEntries(aromaSplitterTriggerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaSplitterTriggerVariantKeys = [
  "orientation"
]
const getVariantProps = (variants) => ({ ...aromaSplitterTriggerDefaultVariants, ...compact(variants) })

export const aromaSplitterTrigger = /* @__PURE__ */ Object.assign(aromaSplitterTriggerFn, {
  __recipe__: false,
  __name__: 'aromaSplitterTrigger',
  raw: (props) => props,
  variantKeys: aromaSplitterTriggerVariantKeys,
  variantMap: {
  "orientation": [
    "horizontal",
    "vertical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, aromaSplitterTriggerVariantKeys)
  },
  getVariantProps
})